import React from 'react'
import classnames from 'classnames'
import { Can } from '@app/context/ability-context'
import { Score } from '@app/constants'

const TourMark = (answer, tour) => {
  if (!answer) { return null }
  else if (answer.score === Score.max) {
    return (<div className={"task__score--" + tour + " task__score--" + tour + "--correctly"} />)
  } else {
    return (<div className={"task__score--" + tour + " task__score--" + tour + "--incorrectly"} />)
  }
}

const MainTourMark = (answer) => {
  const classes = classnames(
    'task__score--main',
    {
      "task__score--main--correctly": answer && answer.score === Score.max,
      "task__score--main--incorrectly": !answer ||  answer && answer.score === Score.min,
      "task__score--main--partially": answer && answer.score !== Score.max && answer.score !== Score.min,
    }
  )

  return (
    <Can I="read main" of="Score">
      <div className={classes}>
        { answer ? answer.score : 0 }
      </div>
    </Can>
  )
}

const Mark = ({ tour, answer }) => {
  return (tour === 'trial' || tour === 'preparatory') ? TourMark(answer, tour) : MainTourMark(answer)
}

export default Mark
